import React from 'react';
import { motion } from 'framer-motion';

const SectionTitle = ({ title, icon = "restaurant-2-fill", className = "", titleIconWhite = false }) => {


  return (
    <motion.div initial={{opacity: 0,y:20}} whileInView={{opacity: 1,y:0}} transition={{duration: 0.5,delay:0.2}} className="section-title-wrapper position-relative">
      <motion.h2 whileHover={{scale:1.05}} whileTap={{scale:0.95}} transition={{duration:0.3}} className={`${className} fw-semibold position-relative`}>
        {title}
      </motion.h2>
      <motion.span initial={{opacity: 0,y:20}} whileInView={{opacity: 1,y:0}} transition={{duration: 0.5,delay:0.2}} className={`title-icon ${titleIconWhite ? "title-icon-white" : "text-danger"} position-absolute`}>
        <i className={`ri-${icon} ${className} fs-20`}></i>
      </motion.span>
    </motion.div>
  );
};

export default SectionTitle;
